<template>
  <div class="d-flex flex-column">
    <label
      v-if="showFullPolicies"
      class="d-block text-uppercase text-muted mb-1"
    >
      POLICIES
    </label>

    <!-- Show Partial Policies -->
    <p
      v-if="showPartialPolicies"
      :style="{ fontSize: fontSize }"
      class="m-0 text-left"
    >
      <span v-if="showAccept"> I accept Rentsync’s </span>
      <a href="http://rentsync.com/terms-of-use" target="_blank">Terms of Use</a>
      <span class="font-weight-bold text-dark"> | </span>
      <a href="http://rentsync.com/privacy-policy" target="_blank">Privacy Policy</a>
      <span class="font-weight-bold text-dark"> | </span>
      <a href="http://rentsync.com/cookie-policy" target="_blank">Cookie Policy</a>
    </p>

    <!-- Multi-line display For Full Policies -->
    <div v-if="showFullPolicies"
      class="flex-column"
    >
      <p :style="{ fontSize: fontSize }" class="mb-1">
        <a href="http://rentsync.com/terms-of-use" target="_blank">Terms of Use</a>
        <span class="font-weight-bold text-dark"> | </span>
        <a href="http://rentsync.com/privacy-policy" target="_blank">Privacy Policy</a>
      </p>
      <p :style="{ fontSize: fontSize }" class="mb-1">
        <a href="http://rentsync.com/cookie-policy" target="_blank">Cookie Policy</a>
        <span class="font-weight-bold text-dark"> | </span>
        <a href="#manage_cookies">Manage Cookies</a>
      </p>
      <p :style="{ fontSize: fontSize }" class="m-0">
        <a href="https://help.rentsync.com/" target="_blank">Help Center</a>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPolicies',

  props: {
    fontSize: {
      type: String,
      default: '16px',
    },
    showFullPolicies: {
      type: Boolean,
      default: false,
    },
    showPartialPolicies: {
      type: Boolean,
      default: false,
    },
    showAccept: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
